module.exports = __webpack_public_path__ + "static/media/flow-sms-en.57f8237d.png";